<template>
  <div class="container-fluid">
    <div class="page-title">
      <i class="fa-regular fa-2x fa-boxes-stacked"></i>
      <h1>{{ $t("COMMON.RESELLER_PRODUCTS") }}</h1>
    </div>
    <div class="page-wrapper">
      <div slot="header" class="page-wrapper-header">
        <div class="row">
          <div class="col-6">
            <h3 class="mb-0">
              {{ $t("RESELLER_PRODUCTS.RESELLER_PRODUCTS_LIST") }}
            </h3>
          </div>
          <div class="col-6 text-right">
            <base-button
              class="elite-button add"
              icon
              size="sm"
              @click="openResellerProductCreateModal"
              v-if="$currentUserCan($permissions.PERM_CREATE_RESELLER_PRODUCTS)"
            >
              <span class="btn-inner--icon">
                <i class="far fa-plus-circle"></i>
              </span>
              <span class="btn-inner--text">{{
                $t("RESELLER_PRODUCTS.ADD_RESELLER_PRODUCT")
              }}</span>
            </base-button>
            <!--<notification-subscription
              v-if="$currentUserCan($permissions.PERM_VIEW_RESELLER_PRODUCTS)"
              :objectType="'reseller-products'"
              :events="{
                CREATE: $t('NOTIFICATIONS.EVENT_CREATE'),
                UPDATE: $t('NOTIFICATIONS.EVENT_UPDATE'),
                DELETE: $t('NOTIFICATIONS.EVENT_DELETE'),
              }"
            />-->
          </div>
        </div>
      </div>

      <reseller-product-list-table
        @onViewResellerProduct="openResellerProductViewModal"
        @onEditResellerProduct="openResellerProductEditModal"
        @onDeleteResellerProduct="deleteResellerProduct"
        :key="renderKey * 100"
      />

      <div
        v-if="isViewResellerProductModalOpened"
        class="resizable-wrapper"
        v-bind:class="[isViewResellerProductModalOpened ? 'show' : 'hide']"
        :key="renderKey * 200"
      >
        <div
          class="resizable-wrapper-content"
          v-resizable-modal="'RESELLER_PRODUCT'"
          @onCloseModal="closeResellerProductModal(true, true)"
        >
          <div class="resizable-wrapper-content-header">
            <div class="resizable-wrapper-content-header-left">
              <h1>
                {{ $t("RESELLER_PRODUCTS.VIEW_RESELLER_PRODUCT") }}
              </h1>
            </div>
            <div class="resizable-wrapper-content-header-right">
              <notification-subscription
                v-if="openResellerProduct"
                :objectType="'reseller-products'"
                :objectId="openResellerProduct.id"
                :events="{
                  UPDATE: $t('NOTIFICATIONS.EVENT_UPDATE'),
                  DELETE: $t('NOTIFICATIONS.EVENT_DELETE'),
                }"
              /><base-dropdown
                title-classes="btn dropdown-button"
                menu-on-right
                :has-toggle="false"
              >
                <template slot="title">
                  <i class="fas fa-ellipsis-v"></i>
                </template>
                <button
                  class="edit"
                  @click="openResellerProductEditModal(openResellerProduct)"
                >
                  <i class="fal fa-edit"></i>
                  <span>{{ $t("COMMON.EDIT") }}</span>
                </button>
                <button
                  class="edit"
                  @click="deleteResellerProduct(openResellerProduct)"
                >
                  <i class="fal fa-trash-alt"></i>
                  <span>{{ $t("COMMON.DELETE") }}</span>
                </button>
              </base-dropdown>
              <button class="close" @click="closeResellerProductModal(true)">
                <i class="fal fa-times"></i>
              </button>
            </div>
          </div>
          <div class="resizable-wrapper-content-body">
            <view-reseller-product-page
              v-if="openResellerProduct"
              :resellerProductId="openResellerProduct.id"
            />
          </div>
        </div>
      </div>

      <div
        v-if="isEditResellerProductModalOpened"
        class="resizable-wrapper"
        v-bind:class="[isEditResellerProductModalOpened ? 'show' : 'hide']"
        :key="renderKey * 300"
      >
        <div
          class="resizable-wrapper-content"
          v-resizable-modal="'RESELLER_PRODUCT'"
          @onCloseModal="closeResellerProductModal(true, true)"
        >
          <div class="resizable-wrapper-content-header">
            <div class="resizable-wrapper-content-header-left">
              <h1>
                {{ $t("RESELLER_PRODUCTS.EDIT_RESELLER_PRODUCT") }}
              </h1>
            </div>
            <div class="resizable-wrapper-content-header-right">
              <button
                class="close"
                @click="openResellerProductViewModal(openResellerProduct)"
              >
                <i class="fal fa-times"></i>
              </button>
            </div>
          </div>
          <div class="resizable-wrapper-content-body">
            <edit-reseller-product-page
              v-if="openResellerProduct"
              :resellerProductId="openResellerProduct.id"
              @onViewResellerProduct="openResellerProductViewModal"
            />
          </div>
        </div>
      </div>

      <div
        v-if="isAddResellerProductModalOpened"
        class="resizable-wrapper"
        v-bind:class="[isAddResellerProductModalOpened ? 'show' : 'hide']"
        :key="renderKey * 400"
      >
        <div
          class="resizable-wrapper-content"
          v-resizable-modal="'RESELLER_PRODUCT'"
          @onCloseModal="closeResellerProductModal(true, true)"
        >
          <div class="resizable-wrapper-content-header">
            <h1>
              {{ $t("RESELLER_PRODUCTS.ADD_RESELLER_PRODUCT") }}
            </h1>
            <button class="close" @click="closeResellerProductModal(true)">
              <i class="fal fa-times"></i>
            </button>
          </div>
          <div class="resizable-wrapper-content-body">
            <add-reseller-product-page
              @onViewResellerProduct="openResellerProductViewModal"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import swal from "sweetalert2";
import { Button } from "element-ui";
import {
  QUERY_ACTIONS_VIEW,
  QUERY_ACTIONS_EDIT,
  QUERY_ACTIONS_ADD,
} from "@/constants/common";
import NotificationSubscription from "@/components/NotificationSubscription.vue";
import ResellerProductListTable from "./partials/ResellerProductListTable.vue";
import EditResellerProductPage from "./components/EditResellerProductComponent.vue";
import AddResellerProductPage from "./components/AddResellerProductComponent.vue";
import ViewResellerProductPage from "./components/ViewResellerProductComponent.vue";
import requestErrorMixin from "@/mixins/request-error-mixin";

export default {
  layout: "DashboardLayout",

  components: {
    ResellerProductListTable,
    NotificationSubscription,
    EditResellerProductPage,
    AddResellerProductPage,
    ViewResellerProductPage,
    [Button.name]: Button,
  },

  mixins: [requestErrorMixin],

  computed: {},

  watch: {},

  data() {
    const locationId = this.$route.query.id;
    const action = this.$route.query.action;
    let isViewResellerProductModalOpened = false;
    let isEditResellerProductModalOpened = false;
    let isAddResellerProductModalOpened = false;
    let openResellerProduct = null;
    if (locationId && action) {
      if (action === QUERY_ACTIONS_VIEW) {
        isViewResellerProductModalOpened = true;
      } else if (action === QUERY_ACTIONS_EDIT) {
        isEditResellerProductModalOpened = true;
      }
      openResellerProduct = { id: locationId };
    } else if (action === QUERY_ACTIONS_ADD) {
      isAddResellerProductModalOpened = true;
    }
    return {
      isViewResellerProductModalOpened: isViewResellerProductModalOpened,
      isEditResellerProductModalOpened: isEditResellerProductModalOpened,
      isAddResellerProductModalOpened: isAddResellerProductModalOpened,
      openResellerProduct: openResellerProduct,
      renderKey: 1,
    };
  },

  methods: {
    openResellerProductCreateModal() {
      this.closeResellerProductModal();
      this.isAddResellerProductModalOpened = true;

      this.$router.replace({
        name: "List ResellerProducts",
        query: { action: QUERY_ACTIONS_ADD },
      });
    },
    openResellerProductViewModal(resellerproduct, reRender = false) {
      this.closeResellerProductModal();
      this.openResellerProduct = resellerproduct;
      this.isViewResellerProductModalOpened = true;
      if (reRender) {
        this.renderKey++;
      }

      this.$router.replace({
        name: "List ResellerProducts",
        query: {
          id: this.openResellerProduct.id,
          action: QUERY_ACTIONS_VIEW,
        },
      });
    },
    openResellerProductEditModal(resellerproduct) {
      this.closeResellerProductModal();
      this.openResellerProduct = resellerproduct;
      this.isEditResellerProductModalOpened = true;

      this.$router.replace({
        name: "List ResellerProducts",
        query: {
          id: this.openResellerProduct.id,
          action: QUERY_ACTIONS_EDIT,
        },
      });
    },
    closeResellerProductModal(goBack = false, grid = false) {
      if (goBack && this.$store.getters["routes/previousPathRoute"]) {
        if (grid) {
          this.$store.dispatch("routes/goBackToPreviousGrid");
        } else {
          this.$store.dispatch("routes/goToPreviousPath");
        }
        return;
      }
      this.isAddResellerProductModalOpened = false;
      this.isViewResellerProductModalOpened = false;
      this.isEditResellerProductModalOpened = false;
      this.openResellerProduct = null;

      if (
        this.$route.name !== "List ResellerProducts" ||
        JSON.stringify(this.$route.query) !== JSON.stringify({})
      ) {
        this.$router
          .replace({
            name: "List ResellerProducts",
            query: {},
          })
          .catch((err) => {
            if (err.name !== "NavigationDuplicated") {
              throw err;
            }
          });
      }
    },

    async deleteResellerProduct(resellerProduct) {
      const confirmation = await swal.fire({
        title: this.$t("RESELLER_PRODUCTS.DELETE_THIS_RESELLER_PRODUCT"),
        type: "question",
        buttonsStyling: false,
        showCancelButton: true,
        confirmButtonText: this.$t("COMMON.YES"),
        cancelButtonText: this.$t("COMMON.NO"),
        confirmButtonClass: "btn btn-primary",
        cancelButtonClass: "btn btn-warning",
      });

      try {
        if (confirmation.isConfirmed) {
          await this.$store.dispatch(
            "resellerProducts/destroy",
            resellerProduct.id
          );
          this.renderKey++;
          this.closeResellerProductModal();
          this.$notify({
            type: "success",
            timeout: 3000,
            message: this.$t("RESELLER_PRODUCTS.RESELLER_PRODUCT_DELETED"),
          });
        }
      } catch (error) {
        await this.showRequestError(error);
        this.$notify({
          type: "danger",
          message: this.$t("ERRORS.SOMETHING_WENT_WRONG"),
        });
      }
    },
  },
};
</script>
